import { useState, useEffect, useCallback } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash/debounce';
import { PrivateScreen } from 'routes/screen-names';
import { selectCustomerDetailSelector } from 'redux/selectors';
import { getDepartments } from '../layout-api';
import { setDepartmentListItems } from '../../../redux/actions/global-actions';

import { useDispatch } from 'react-redux';
import SessionStorageManager from 'utils/session-storage-manager';

export const useDepartmentsBar = () => {
  const navigate = useNavigate();
  const customerDetail = useSelector(selectCustomerDetailSelector);
  const [openMegaMenu, setOpenMegaMenu] = useState(false);
  const [openMoreMenu, setOpenMoreMenu] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [menuButtonXPosition, setMenuButtonXPosition] = useState(0);
  const [timeoutId, setTimeoutId] = useState(null);
  let timer;
  const [showAndMore, setShowAndMore] = useState(false);
  const [departmentContainerWidth, setDepartmentContainerWidth] = useState(0);

  const { data: departments = [], isLoading: departmentsLoading } = useQuery(
    ['getDepartments'],
    () => getDepartments(),
    {
      cacheTime: 3600000,
      staleTime: 3600000,
      select: (data) => {
        return data?.data?.data || [];
      },
    }
  );
  useEffect(() => {
    if (departments) {
      const parent = document.querySelector('.header2-container');
      const children = parent?.querySelectorAll('.child-element');
      let totalWidth = 0;
      let bool = true;
      let tempValue = 0;
      let lastChild;
      let x = 0;

      if (children) {
        children.forEach((child) => {
          totalWidth += child.offsetWidth + 35;
          // tempValue = totalWidth;
          if (bool && totalWidth >= parent.offsetWidth) {
            // tempValue = totalWidth - child.offsetWidth;
            tempValue = x - lastChild;
            bool = false;
          }
          lastChild = child.offsetWidth + 40;
          x += child.offsetWidth + 35;
        });
      }
      if (tempValue > 0) setDepartmentContainerWidth(tempValue);
      else setDepartmentContainerWidth(parent?.offsetWidth);
      if (totalWidth >= parent?.offsetWidth) {
        document.getElementById('and-more').style.display = 'block';
      }
    }
  }, [departments]);

  const handleOpenMegaMenu = (department, menuButtonXPosition) => {
    setOpenMoreMenu(false);
    setOpenMegaMenu(true);
    setSelectedDepartment(department);
    setMenuButtonXPosition(menuButtonXPosition);
  };

  const handleCloseMegaMenu = () => {
    setOpenMegaMenu(false);
    setSelectedDepartment();
  };

  const handleOpenMoreMenu = () => {
    setOpenMegaMenu(false);
    setOpenMoreMenu(true);
  };

  const handleCloseMoreMenu = () => {
    setOpenMoreMenu(false);
  };

  const handleShopByLookBookClick = () => {
    navigate(PrivateScreen.lookbooks);
  };

  const dispatch = useDispatch();

  const handleDepartmentClick = useCallback(
    debounce((department) => {
      dispatch(
        setDepartmentListItems([
          {
            genderId: department.genderId,
            collectionId: department.col,
          },
        ])
      );
      SessionStorageManager.removeSessionStorage('filters');
      SessionStorageManager.removeSessionStorage('searchFilters');

      handleCloseMegaMenu();
      handleCloseMoreMenu();
      navigate({
        pathname: '/catalog',
        search: `?gndr=${department.genderId}&cl=${department.col}&resetCatalog=true&start=0`,
      });
    }, 1000), // wait for 1s to start
    [] // dependencies for useCallback
  );

  return {
    departments,
    departmentsLoading,
    handleOpenMegaMenu,
    handleCloseMegaMenu,
    handleOpenMoreMenu,
    handleCloseMoreMenu,
    openMegaMenu,
    openMoreMenu,
    selectedDepartment,
    customerDetail,
    handleShopByLookBookClick,
    handleDepartmentClick,
    menuButtonXPosition,
    timeoutId,
    setTimeoutId,
    departmentContainerWidth,
  };
};
